<template>
	<b-modal
		hide-footer
		ref="modal-view-inherited"
		size="lg"
		title="Agregar/Quitar tipos de servicios a las tarifas heredadas"
	>
		<b-overlay :show="loading" no-wrap></b-overlay>
		<b-row>
			<b-col cols="12" class="mb-2">
				<div class="alert-light alert bg-light">
					<p class="mb-0">
						Tarifa: <strong>{{ parentRateName }}</strong>
					</p>
				</div>
				<hr />
			</b-col>

			<b-form-group class="col-lg-5">
				<div class="alert-light alert bg-light">
					<p class="mb-1"><strong>Resumen de tarifa</strong></p>
					<hr />
					<p class="mb-0">
						Área: <strong>{{ area }}</strong
						><br />
						Moneda: <strong>{{ currency }}</strong
						><br />
						Tipos de servicio:<br />
					</p>
					<ul>
						<li
							v-for="serviceType in serviceTypes"
							:key="serviceType.value"
						>
							{{ serviceType.text }}
						</li>
					</ul>
				</div>
			</b-form-group>

			<b-col lg="7">
				<b-row>
					<b-col lg="12" class="mb-3">
						<b-form-group label="Tipos de servicio*">
							<b-form-select
								size="sm"
								v-model="serviceTypeId"
								:options="serviceTypes"
								required
							/>
						</b-form-group>
					</b-col>
					<b-col lg="12" class="mb-3">
						<b-form-group label="Tarifas heredadas*">
							<multiselect
								v-model="inheritedRatePlansSelected"
								:options="inheritedRatePlansOpts"
								group-label="group"
								group-values="options"
								group-select
								multiple
								label="text"
								track-by="value"
								:close-on-select="false"
								taggable
							/>
						</b-form-group>
					</b-col>

					<b-col cols="12">
						<b-button
							v-if="$hasPermission('rates.serviceType.add')"
							:disabled="serviceTypeId == null"
							@click="sendServiceTypes('add')"
							variant="primary"
							class="mr-3"
							>Agregar</b-button
						>
						<b-button
							v-if="$hasPermission('rates.serviceType.delete')"
							:disabled="serviceTypeId == null"
							@click="sendServiceTypes('remove')"
							variant="danger"
							>Quitar</b-button
						>
					</b-col>
				</b-row>
			</b-col>
		</b-row>
	</b-modal>
</template>

<script>
import Multiselect from "vue-multiselect";
export default {
	components: { Multiselect },
	data() {
		return {
			modelId: -1,
			loading: true,
			area: "",
			parentRateName: "",
			currency: "",
			inheritedRates: [],
			serviceTypes: [],
			applyServices: [],
			serviceTypeId: null,
			inheritedRatePlansSelected: []
		};
	},
	methods: {
		loadModel(id) {
			this.modelId = id;
			this.loadInheritedRates();
			this.loadParent();
			this.$refs["modal-view-inherited"].show();

			// reset v-models
			this.inheritedRatePlansSelected = [];
			this.serviceTypeId = null;
		},
		loadInheritedRates() {
			this.loading = true;
			this.$root.api
				.get(`/rate-plans/${this.modelId}/inherited`)
				.then(res => {
					this.inheritedRates = res.data;
				})
				.catch(this.$root.handleRequestError)
				.then(() => {
					this.loading = false;
				});
		},
		loadParent() {
			this.loading = true;
			this.$root.api
				.get(`/rate-plans/${this.modelId}`)
				.then(res => {
					this.area = res.data.zonedArea.name;
					this.parentRateName = res.data.title;
					this.currency = res.data.currency.toUpperCase();

					this.serviceTypes = res.data.serviceTypes.map(st => ({
						value: st.id,
						text: st.name
					}));
				})
				.catch(this.$root.handleRequestError)
				.then(() => {
					this.loading = false;
				});
		},
		sendServiceTypes(action) {
			if (this.inheritedRatePlansSelected.length == 0) {
				this.$root.showAlert(
					"Seleccione al menos una Tarifa heredada",
					{
						variant: "warning"
					}
				);
				return false;
			}

			this.loading = true;
			let data = {
				action: action,
				inheritedRates: this.inheritedRatePlansSelected
			};

			this.$root.api
				.post(`/rate-plans/${this.serviceTypeId}/inherited`, data)
				.then(res => {
					if (res.data.success)
						this.$root.showAlert(res.data.success);
				})
				.catch(this.$root.handleRequestError)
				.then(() => {
					this.loading = false;
				});
		}
	},
	computed: {
		inheritedRatePlansOpts() {
			let rates = {};
			if (this.inheritedRates.length > 0)
				rates = this.inheritedRates.map(i => ({
					value: i.id,
					text: `${
						i.salesChannelName != ""
							? "Canal: " + i.salesChannelName
							: "Supplier: " + i.supplierName
					} || ${i.title}`
				}));
			else rates = null;

			return [{ group: "SELECT ALL", options: rates }];
		}
	},
	mounted() {
		this.$root.auxVars.loadResourcesOpts({
			vm: this,
			resourceNames: [
				"zonedAreasOpts",
				"salesChannelsOpts",
				"suppliersOpts",
				"serviceTypesOpts"
			]
		});
	}
};
</script>
